import React from 'react';
import { StyleSheet, Text, View, Dimensions, TextInput,TouchableOpacity } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

export default function ButtonGradient({texto}){

    return (

                <LinearGradient 
                    colors={['#4c669f', '#3b5998', '#192f6a']}
                    start={{x:1, y:0}}
                    end={{x:0, y:1}}
                    style={styles.button}
                   >
                    <Text style={styles.text}>{texto}</Text>
                </LinearGradient>

    );


}

const styles = StyleSheet.create({

    text: {
        fontSize: 20,
        color: 'white',
        borderRadius: 30,
        fontWeight: 'bold'

    },
    button:{

    width: "100%",
    height: "100%",
    borderRadius: 10, 
    alignItems: 'center',
    justifyContent : 'center'

    }


});